module.exports = __webpack_public_path__ + "img/Nav_back.15feef39.svg";